(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/xperten.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/xperten.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Xperten = Backbone.Marionette.View.extend({
    useBaseRow: false,
    template: function(data) {
      return svs.maltipset.templates.xperten(data);
    },
    className: 'padding-1 padding-bottom-0',
    events: {
      'click .js-btn-xperten': 'onXpertenClick',
      'change .js-btn-xperten-create-row': 'onBaseRowSelect',
      'click .js-help-dialog-board-row': 'helpDialogBoardRow'
    },
    initialize: function() {
      this.originalUseBaseRow = this.useBaseRow = this.model.get(
        'xpertBaseRowMode'
      );

      if (
        svs.utils.ns.isNamespace(
          'svs.core.config.data.svsconfig.isSelfService'
        ) &&
        svs.core.config.data.svsconfig.isSelfService === true
      ) {
        this.model.set('minNoOfRows', 4);
        this.model.set('maxNoOfRows', 12);
      } else {
        this.model.set('minNoOfRows', 1);
        this.model.set('maxNoOfRows', 14);
      }

      if (
        (this.model.get('xpertSystem') !==
          svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT &&
          this.model.get('xpertSystem') !==
            svs.maltipset.constants.XPERT_PROPERTIES.MODIFIEDQP) ||
        this.model.get('xpertBaseRowMode')
      ) {
        this.changeDoneButtonState(false);
        this.systemSize = this.model.get('xpertSize');
        this.originalSystemSize = this.model.get('xpertSize');
      }
    },
    changeDoneButtonState: function(disabled) {
      $('.modal-button-right').prop('disabled', disabled);
    },
    onXpertenClick: function(event) {
      this.changeDoneButtonState(false);
      this.systemSize = parseInt(
        event.currentTarget.attributes['data-system'].value,
        10
      );
      this.changed =
        this.changed || this.systemSize !== this.originalSystemSize;
    },
    onBaseRowSelect: function(e) {
      this.useBaseRow = e.target.checked;
      this.changed =
        this.changed || this.useBaseRow !== this.originalUseBaseRow;
    },

    helpDialogBoardRow: function(e) {
      if (svs.maltipset.data.config.helpTexts) {
        var _dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1400,
          title: svs.maltipset.data.config.helpTexts.xperten_board_row.title,
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: svs.maltipset.data.config.helpTexts.xperten_board_row.body
            }
          ]
        });
        svs.components.dialog.api.add(_dialog);
      }
    }
  });
})(Backbone, _, svs);

 })(window);